import { Box } from '@mui/material';
import { memo } from 'react';
import { noop } from 'shell/utils/noop';
import { StickyDiv } from 'shell/components/shared/sticky-div';
import { PmiButton } from 'shell/components/shared/button';

interface CancellationUnderageStepButtonsProps {
  onCancel?: () => void;
}

const CancellationUnderageStepButtonsComponent = ({
  onCancel,
}: CancellationUnderageStepButtonsProps): React.ReactElement => {
  return (
    <StickyDiv>
      <div>
        <div className="pmi-pb-2">
          <PmiButton
            variant="outlined"
            color="cdmBrandThird"
            fullWidth
            type="submit"
            // disabled={!formContext.isValid && formContext.submitCount > 0}
          >
            <Box
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              CONFERMA
            </Box>
          </PmiButton>
        </div>
        <div className="pmi-pb-2">
          <PmiButton variant="outlined" color="cdmBrandThird" fullWidth type="reset">
            <Box
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              Pulisci
            </Box>
          </PmiButton>
        </div>
      </div>
      <PmiButton variant="contained" color="cdmBrand" fullWidth onClick={onCancel || noop}>
        ANNULLA OPERAZIONE
      </PmiButton>
    </StickyDiv>
  );
};

CancellationUnderageStepButtonsComponent.displayName = 'Cancellation underage buttons component';

const CancellationUnderageStepButtons = memo(CancellationUnderageStepButtonsComponent);

export default CancellationUnderageStepButtons;
